<!-- K线图 -->
<template>
  <div class="k-line-box">
    <fund-chart-legend
      :is-touched="isTouched"
      :line-chart-type="`kLine`"
      :legend-value-list="legendValueList" />
    <div class="ma-box">
      <div class="ma-5">{{`MA5: ${this.MA5 || '--'}`}}</div>
      <div class="ma-10">{{`MA10: ${this.MA10 || '--'}`}}</div>
      <div class="ma-20">{{`MA20: ${this.MA20 || '--'}`}}</div>
    </div>
    <div class="k-line-padding">
    <div class="k-line-chart-box" id="k-line-chart-box">
      <k-line-chart
        :auto-init="false"
        :config="config"
        :request-data="getData"
        @afterRender="handleAfterRender"
        @onChangeToolTip="toolTipChange"
        @onHideToolTip="toolTipHide"
        ref="chart"/>
      <!-- 缩放按钮 -->
      <div class="k-btn-group">
        <img
          :src="reduceImg"
          :style="{ opacity: this.currentIndex === this.limitDaysArray.length-1 ? 0.5 : 1 }"
          @click="reduce"
          class="k-btn-img" />
        <img
          :src="addImg"
          :style="{ opacity: this.currentIndex === 0 ? 0.5 : 1 }"
          @click="add"
          class="k-btn-img" />
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { KLineChart } from '@fund/f2-chart-h5';
import tool from '@/utils/tool';
import FundChartLegend from './FundChartLegend.vue';

export default {
  name: 'fund-k-line',

  components: {
    KLineChart,
    FundChartLegend,
  },

  props: {
    lineChartType: {
      type: String,
      default: '',
    },
    fundCode: {
      type: String,
      default: '',
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      chartWidth: 0,
      currentIndex: 4,
      legendValueList: [], // 图例数据
      originLegendList: [], // 图例原始数据
      MA5: '--',
      MA10: '--',
      MA20: '--',
      originMA5: '--',
      originMA10: '--',
      originMA20: '--',
      limitDaysArray: [30, 35, 40, 45, 50, 60, 75, 95],
      isTouched: false, // 是否长按
      reduceImg: 'https://j5.dfcfw.com/sc/image/202202/20220228051800.png',
      addImg: 'https://j5.dfcfw.com/sc/image/202202/20220228051743.png',
    };
  },

  computed: {
    config() {
      return {
        lineChart: {
          width: this.chartWidth,
          height: 200,
          yAxisConfig: {
            tipFormatter: (value) => (`${parseFloat(value)?.toFixed(3) || '--'}`),
          },
        },
        barChart: {
          width: this.chartWidth,
          height: 80,
          xAxisConfig: {},
          yAxisConfig: {
            tipFormatter: (value) => (tool.formateBigNumber(value) || '--'),
          },
        },
        throttleTime: 300,
      };
    },
    kCode() {
      const kMap = {
        KOfDay: 101,
        KOfWeek: 102,
        KOfMonth: 103,
      };
      return kMap[this.lineChartType] || 101;
    },
    limitDays() {
      return this.limitDaysArray[this.currentIndex];
    },
  },

  watch: {
    kCode() {
      this.$refs.chart.start();
    },
    limitDays() {
      this.$refs.chart.start();
    },
  },

  mounted() {
    const boxEle = document.getElementById('k-line-chart-box');
    this.chartWidth = boxEle.offsetWidth;
    setTimeout(() => {
      this.$refs.chart.start();
    }, 1500);
  },

  methods: {
    // 获取k线图数据
    async getData() {
      const curDate = new Date();
      const setZero = (num) => (num >= 10 ? `${num}` : `0${num}`);
      const params = {
        secid: `${this.detailInfo?.newMarketCode || 0}.${this.fundCode}`,
        fields1: 'f1,f2,f3,f4,f5,f6,f7,f8,f8,f10,f11',
        fields2: 'f51,f52,f53,f54,f55,f56,f57,f59',
        iscr: '0',
        fqt: 1,
        lmt: this.limitDays,
        end: `${curDate.getFullYear()}${setZero(curDate.getMonth() + 1)}${setZero(curDate.getDate())}`,
        ut: 'a7202e6f901554f7cfadffa430c882bf',
        klt: this.kCode || 101,
        authorityType: 'fa',
        dpt: 'ttjj.xtb',
        fundCode: this.fundCode,
        currentIndex: this.currentIndex,
      };
      console.log(params);
      const res = await this.$http.useRequests('Push2His.getKLineData', params)
        .catch((err) => { console.log('getKLineData ERR', err); });
      console.log('===> getKLineData', res);
      return res?.data || {};
    },

    // 处理图表抛出数据
    handleAfterRender(data) {
      console.log('====> handleAfterRender', data);
      if (!this.$isEmpty(data)) {
        const lastPoint = data[data.length - 1];
        const {
          date, lastPrice, volume, MA5, MA10, MA20, syl,
        } = lastPoint; // TODO 涨跌幅需要图表配合
        this.legendValueList = [{
          date,
          type: 'price-point',
          value: lastPrice,
        }, {
          date,
          type: 'volume-point',
          value: volume,
        }, {
          date,
          type: 'rise-point',
          value: syl,
        }];
        this.MA5 = tool.formateFixedNumber(MA5, 3) || '--';
        this.MA10 = tool.formateFixedNumber(MA10, 3) || '--';
        this.MA20 = tool.formateFixedNumber(MA20, 3) || '--';
        this.originMA5 = this.MA5;
        this.originMA10 = this.MA10;
        this.originMA20 = this.MA20;
        this.originLegendList = this.legendValueList;
      }
    },

    toolTipChange(e) {
      const {
        date, lastPrice, volume, MA5, MA10, MA20, syl,
      } = e;
      this.legendValueList = [{
        date,
        type: 'price-point',
        value: lastPrice,
      }, {
        date,
        type: 'volume-point',
        value: volume,
      }, {
        date,
        type: 'rise-point',
        value: syl,
      }];
      this.MA5 = tool.formateFixedNumber(MA5, 3) || '--';
      this.MA10 = tool.formateFixedNumber(MA10, 3) || '--';
      this.MA20 = tool.formateFixedNumber(MA20, 3) || '--';
      this.isTouched = true;
    },

    toolTipHide() {
      this.MA5 = this.originMA5;
      this.MA10 = this.originMA10;
      this.MA20 = this.originMA20;
      this.legendValueList = this.originLegendList;
      this.isTouched = false;
    },

    // 缩小显示-增加展示范围，currentIndex +1
    reduce() {
      if (this.currentIndex < this.limitDaysArray.length - 1) {
        this.currentIndex += 1;
      }
    },
    // 增大显示-缩小展示范围，currentIndex -1
    add() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
      }
    },
  },

};
</script>

<style lang="less" scoped>
.k-line-box {
  box-sizing: border-box;
  // padding: 0 24px;
  width: 100%;
  .ma-box {
    margin: 0 24px;
    box-sizing: border-box;
    // width: 100%;
    border-top: 1px solid rgb(238, 238, 238);
    border-left: 1px solid rgb(238, 238, 238);
    border-right: 1px solid rgb(238, 238, 238);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    line-height: 36px;
    padding-left: 4px;
    .ma-5 {
      flex: 1;
      color: #008aff
    }
    .ma-10 {
      flex: 1;
      color: #ffa800;
    }
    .ma-20 {
      flex: 1;
      color: #ba33ff;
    }
  }
  .k-line-padding {
    padding: 0 24px;
  }
  .k-line-chart-box {
    width: 100%;
    box-sizing: border-box;
    position: relative;
    .k-btn-group {
      position: absolute;
      top: 240px;
      right: 0;
      .k-btn-img {
        width: 60px;
        height: 60px;
        margin-right: 24px;
      }
    }
  }
}

</style>
